function y(e) {
  const s = "([0-9]_*)+", c = "([0-9a-fA-F]_*)+", r = "([01]_*)+", b = "([0-7]_*)+", o = "([!#$%&*+.\\/<=>?@\\\\^~-]|(?!([(),;\\[\\]`|{}]|[_:\"']))(\\p{S}|\\p{P}))", n = { variants: [
    // Double dash forms a valid comment only if it's not part of legal lexeme.
    // See: Haskell 98 report: https://www.haskell.org/onlinereport/lexemes.html
    //
    // The commented code does the job, but we can't use negative lookbehind,
    // due to poor support by Safari browser.
    // > hljs.COMMENT(`(?<!${symbol})--+(?!${symbol})`, '$'),
    // So instead, we'll add a no-markup rule before the COMMENT rule in the rules list
    // to match the problematic infix operators that contain double dash.
    e.COMMENT("--+", "$"),
    e.COMMENT(
      /\{-/,
      /-\}/,
      { contains: ["self"] }
    )
  ] }, t = {
    className: "meta",
    begin: /\{-#/,
    end: /#-\}/
  }, l = {
    className: "meta",
    begin: "^#",
    end: "$"
  }, i = {
    className: "type",
    begin: "\\b[A-Z][\\w']*",
    // TODO: other constructors (build-in, infix).
    relevance: 0
  }, a = {
    begin: "\\(",
    end: "\\)",
    illegal: '"',
    contains: [
      t,
      l,
      {
        className: "type",
        begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
      },
      e.inherit(e.TITLE_MODE, { begin: "[_a-z][\\w']*" }),
      n
    ]
  }, d = {
    begin: /\{/,
    end: /\}/,
    contains: a.contains
  }, m = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal floating-point-literal (subsumes decimal-literal)
      { match: `\\b(${s})(\\.(${s}))?([eE][+-]?(${s}))?\\b` },
      // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
      { match: `\\b0[xX]_*(${c})(\\.(${c}))?([pP][+-]?(${s}))?\\b` },
      // octal-literal
      { match: `\\b0[oO](${b})\\b` },
      // binary-literal
      { match: `\\b0[bB](${r})\\b` }
    ]
  };
  return {
    name: "Haskell",
    aliases: ["hs"],
    keywords: "let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",
    unicodeRegex: !0,
    contains: [
      // Top-level constructions.
      {
        beginKeywords: "module",
        end: "where",
        keywords: "module where",
        contains: [
          a,
          n
        ],
        illegal: "\\W\\.|;"
      },
      {
        begin: "\\bimport\\b",
        end: "$",
        keywords: "import qualified as hiding",
        contains: [
          a,
          n
        ],
        illegal: "\\W\\.|;"
      },
      {
        className: "class",
        begin: "^(\\s*)?(class|instance)\\b",
        end: "where",
        keywords: "class family instance where",
        contains: [
          i,
          a,
          n
        ]
      },
      {
        className: "class",
        begin: "\\b(data|(new)?type)\\b",
        end: "$",
        keywords: "data family type newtype deriving",
        contains: [
          t,
          i,
          a,
          d,
          n
        ]
      },
      {
        beginKeywords: "default",
        end: "$",
        contains: [
          i,
          a,
          n
        ]
      },
      {
        beginKeywords: "infix infixl infixr",
        end: "$",
        contains: [
          e.C_NUMBER_MODE,
          n
        ]
      },
      {
        begin: "\\bforeign\\b",
        end: "$",
        keywords: "foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",
        contains: [
          i,
          e.QUOTE_STRING_MODE,
          n
        ]
      },
      {
        className: "meta",
        begin: "#!\\/usr\\/bin\\/env runhaskell",
        end: "$"
      },
      // "Whitespaces".
      t,
      l,
      // Literals and names.
      // Single characters.
      {
        scope: "string",
        begin: /'(?=\\?.')/,
        end: /'/,
        contains: [
          {
            scope: "char.escape",
            match: /\\./
          }
        ]
      },
      e.QUOTE_STRING_MODE,
      m,
      i,
      e.inherit(e.TITLE_MODE, { begin: "^[_a-z][\\w']*" }),
      // No markup, prevents infix operators from being recognized as comments.
      { begin: `(?!-)${o}--+|--+(?!-)${o}` },
      n,
      {
        // No markup, relevance booster
        begin: "->|<-"
      }
    ]
  };
}
export {
  y as default
};
